<div class="approved-proposal__wrapper">
  <img src='/assets/images/proposal-status/approved.png'>

  <h4 class="approved-proposal__title">
    Proposta aprovada!
  </h4>
</div>

<fd-button [content]="'OK'" (trigger)="navigateToHome()">
</fd-button>